import apiRoads from '../../api/roads'

// initial state
const state = {
    roads: {},
    visibleRoads: []
}

// getters
const getters = {
    visibleRoads(state) {
        return state.visibleRoads
    },
    sortedRoads(state, getters) {
        const copy = getters.visibleRoads.filter(() => {return true})
        return copy.sort((l,r) => {
            return l < r ? -1 : 1
        })
    }
}

// actions
const actions = {
    getRoad ({commit}, {number}) {
        if (number in state.roads) {
            return state.roads[number]
        }
        return apiRoads.getRoad(number).then((road) => {
            commit('setRoad', road)
            return road
        })
    },
    getRange ({dispatch, commit}, range) {
        // Filter the range down to ones we do not already have
        const toFetch = range.filter((r) => {
            return !(r in state.roads)
        });
        const alreadyGot  = range.filter((r) => {
            return r in state.roads
        });

        // Get the remaining range
        let promises = [], roads = []
        toFetch.forEach((n) => {
            promises.push(
                dispatch('getRoad', {number: n}).then((r) => {
                    commit('setRoad', r)
                    roads.push(r)
                })
            )
        })

        return Promise.all(promises).then(() => {
            // Add in the ones we've already got
            alreadyGot.forEach((r) => {
                roads.push(state.roads[r])
            })
            // Return the combined list
            return roads
        })
    }
}

// mutations
const mutations = {
    setRoad(state, road) {
        state.roads[road.number] = road
    },
    pushVisibleRoad(state, number) {
        state.visibleRoads.push(parseInt(number))
    },
    popVisibleRoad(state, number) {
        let n = state.visibleRoads.indexOf(number)
        state.visibleRoads.splice(n, 1)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}